document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('QuickViewModal');
  const content = document.getElementById('QuickViewContent');

  if (!modal || !content) return;

  let scrollPosition = 0;

  function openModal() {
    scrollPosition = window.scrollY;

    modal.hidden = false;
    modal.classList.add('is-active');

    document.body.classList.add('quick-view-open');
    document.body.style.top = `-${scrollPosition}px`;
  }

  function closeModal() {
    const panel = document.querySelector('.quick-view-panel');
    if (panel) panel.style.transform = '';

    modal.hidden = true;
    modal.classList.remove('is-active');

    document.body.classList.remove('quick-view-open');

    const scrollY = document.body.style.top;
    document.body.style.top = '';

    window.scrollTo(0, parseInt(scrollY || '0') * -1);

    content.innerHTML = '';
  }

  function resetPanelPosition() {
    const panel = document.querySelector('.quick-view-panel');
    if (panel) panel.style.transform = '';
  }

  function shiftPanelForDropdown(menu) {
  const panel = document.querySelector('.quick-view-panel');
  if (!panel || !menu) return;

  panel.style.transform = '';

  requestAnimationFrame(() => {
    const menuRect = menu.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (menuRect.bottom > viewportHeight - 16) {
      const overflow = menuRect.bottom - viewportHeight + 24;
      panel.style.transform = `translateY(-${overflow}px)`;
    }
  });
}

  function initQuickViewForm() {
    const form = document.getElementById('QuickViewProductForm');
    const variantsJson = document.getElementById('QuickViewVariantsJson');
    const optionsJson = document.getElementById('QuickViewOptionsJson');
    const variantIdInput = form?.querySelector('[data-quick-view-variant-id]');
    const priceEl = document.querySelector('[data-quick-view-price]');

    if (!form || !variantsJson || !optionsJson || !variantIdInput) return;

    const variants = JSON.parse(variantsJson.textContent);
    const options = JSON.parse(optionsJson.textContent);

    let selectedOptions = options.map((option) => option.selected_value || option.values[0]);

    function findVariant() {
      return variants.find((variant) => {
        return variant.options.every((value, index) => value === selectedOptions[index]);
      });
    }

    function updateUI() {
      const matchedVariant = findVariant();

      document.querySelectorAll('[data-option-index][data-option-value]').forEach((el) => {
        const optionIndex = Number(el.dataset.optionIndex);
        const optionValue = el.dataset.optionValue;
        const isSelected = selectedOptions[optionIndex] === optionValue;

        el.classList.toggle('is-selected', isSelected);
      });

      document.querySelectorAll('[data-quick-view-select]').forEach((selectEl) => {
        const label = selectEl.querySelector('[data-quick-view-select-label]');
        const selectedOptionButton = selectEl.querySelector('.quick-view-select__option.is-selected');

        if (label && selectedOptionButton) {
          label.textContent = selectedOptionButton.textContent.trim();
        }
      });

      const submitButton = form.querySelector('[type="submit"]');

      if (!matchedVariant || !matchedVariant.available) {
        variantIdInput.value = '';

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = window.languages?.productFormSoldOut || 'Sold out';
        }

        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = window.languages?.productFormAddToCart || 'Add to cart';
      }

      if (priceEl && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        priceEl.innerHTML = Shopify.formatMoney(
          matchedVariant.price,
          window.theme?.moneyFormat || '${{amount}}'
        );
      } else if (priceEl) {
        priceEl.textContent = (matchedVariant.price / 100).toFixed(2);
      }
    }

    document.querySelectorAll('.quick-view-packaging-item').forEach((button) => {
      button.addEventListener('click', () => {
        const optionIndex = Number(button.dataset.optionIndex);
        selectedOptions[optionIndex] = button.dataset.optionValue;
        updateUI();
      });
    });

    document.querySelectorAll('[data-quick-view-select]').forEach((selectEl) => {
      const trigger = selectEl.querySelector('[data-quick-view-select-trigger]');
      const menu = selectEl.querySelector('[data-quick-view-select-menu]');

      if (!trigger || !menu) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        document.querySelectorAll('[data-quick-view-select-trigger]').forEach((otherTrigger) => {
          otherTrigger.setAttribute('aria-expanded', 'false');
        });

        document.querySelectorAll('[data-quick-view-select-menu]').forEach((otherMenu) => {
          otherMenu.hidden = true;
        });

        resetPanelPosition();

        trigger.setAttribute('aria-expanded', String(!isOpen));
        menu.hidden = isOpen;

      if (!isOpen) {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        setTimeout(() => {
          if (isMobile) {
            const panel = document.querySelector('.quick-view-panel');

            if (panel) {
              panel.scrollTo({
                top: panel.scrollHeight,
                behavior: 'smooth'
              });
            }
          } else {
            shiftPanelForDropdown(menu);
          }
        }, 50);
      }
      });

      menu.querySelectorAll('.quick-view-select__option').forEach((optionButton) => {
        optionButton.addEventListener('click', (event) => {
          event.preventDefault();

          const optionIndex = Number(optionButton.dataset.optionIndex);
          selectedOptions[optionIndex] = optionButton.dataset.optionValue;

          menu.querySelectorAll('.quick-view-select__option').forEach((btn) => {
            btn.classList.remove('is-selected');
          });

          optionButton.classList.add('is-selected');

          const label = selectEl.querySelector('[data-quick-view-select-label]');
          if (label) label.textContent = optionButton.textContent.trim();

          trigger.setAttribute('aria-expanded', 'false');
          menu.hidden = true;

          resetPanelPosition();
          updateUI();
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-quick-view-select]')) {
        document.querySelectorAll('[data-quick-view-select-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        document.querySelectorAll('[data-quick-view-select-menu]').forEach((menu) => {
          menu.hidden = true;
        });

        resetPanelPosition();
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const matchedVariant = findVariant();

      if (!matchedVariant || !matchedVariant.available) {
        console.error('Cannot add to cart: variant unavailable');
        return;
      }

      variantIdInput.value = matchedVariant.id;

      const formData = new FormData(form);

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || 'Add to cart failed');
        }

        const addedProduct = await response.json();

        closeModal();

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            product: addedProduct,
            quantity: Number(formData.get('quantity') || 1)
          }
        }));
      } catch (error) {
        console.error('Quick view add to cart error:', error);
      }
    });

    updateUI();
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.quick-view-trigger');
    const closeButton = event.target.closest('[data-quick-view-close]');

    if (closeButton) {
      event.preventDefault();
      closeModal();
      return;
    }

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = trigger.dataset.productHandle;
    if (!handle) return;

    openModal();
    content.innerHTML = '<div class="quick-view-loading">Loading...</div>';

    try {
      const response = await fetch(`/products/${handle}?section_id=quick-view-product`);

      if (!response.ok) {
        throw new Error(`Quick view request failed: ${response.status}`);
      }

      content.innerHTML = await response.text();
      initQuickViewForm();
      
    } catch (error) {
      console.error('Quick view fetch error:', error);
      content.innerHTML = '<p>Could not load product.</p>';
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
});